export const humanitiesData = {
  departmentName: "Department of Humanities & Social Sciences",
  bannerImage: "/infrastructure/hs/lab-1.JPG",
  
  about: {
    title: "About the Department",
    content: `The Department of Humanities & Social Sciences at Rayalaseema University provides a comprehensive 
    understanding of human behavior, society, culture, and communication. Our interdisciplinary programs cover 
    sociology, psychology, philosophy, communication studies, and development studies. We focus on developing 
    critical thinking, ethical reasoning, and social awareness, preparing students for careers in education, 
    social work, public administration, and research.`,
    highlights: [
      "Interdisciplinary approach to social sciences",
      "Research focus on regional development and social issues",
      "Community engagement and outreach programs",
      "Seminars and workshops on contemporary social topics"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/humanities/department-brochure.pdf",
    description: "Download our comprehensive department brochure for detailed information about programs, facilities, and achievements."
  },

  hod: {
    id:'hs001',
  name: "Dr. S. Naga Chandrudu",
    designation: "Co-ordinator & Assistant Professor (Ad hoc)",
    email: "chandu.rucek@gmail.com",
    mobile: "+91 82472 88315",
    photo: "/hs/nagachandrudu.JPG",
    qualification: "B.Sc., M.Sc., Ph.D.",
    specialization: "Developmental Economics",
    profileLink: "/hs/nagachandrudu.pdf",
    message: `Welcome to the Department of Humanities & Social Sciences. We are dedicated to understanding the 
    complexities of human society and culture. Our programs encourage students to think critically about social 
    issues and develop insights that can contribute to positive social change.`,

  },

  bos: {
    title: "Board of Studies",
    members: [
      // {
      //   name: "Prof. Vijay Kumar",
      //   designation: "Chairman",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Dr. Gayatri Devi",
      //   designation: "Member",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Dr. Shankar Rao",
      //   designation: "Member",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Prof. External Expert",
      //   designation: "External Member",
      //   affiliation: "Social Research Institute"
      // }
    ]
  },

  faculty: [
    {
      id:'hs001',
    name: "Dr. S. Naga Chandrudu",
    designation: "Co-ordinator & Assistant Professor (Ad hoc)",
    email: "chandu.rucek@gmail.com",
    mobile: "+91 82472 88315",
    photo: "/hs/nagachandrudu.JPG",
    qualification: "B.Sc., M.Sc., Ph.D.",
    specialization: "Developmental Economics",
    profileLink: "/hs/nagachandrudu.pdf"
  }
  ],

  courses: {
    undergraduate: [
      // {
      //   name: "B.A. Sociology",
      //   duration: "3 Years",
      //   eligibility: "10+2 in any stream",
      //   intake: "60 seats"
      // },
      // {
      //   name: "B.A. Psychology",
      //   duration: "3 Years",
      //   eligibility: "10+2 in any stream",
      //   intake: "40 seats"
      // }
    ],
    // postgraduate: [
    //   {
    //     name: "M.A. Sociology",
    //     duration: "2 Years",
    //     eligibility: "B.A. with Sociology or related field",
    //     intake: "30 seats"
    //   },
    //   {
    //     name: "M.A. Psychology",
    //     duration: "2 Years",
    //     eligibility: "B.A. with Psychology",
    //     intake: "25 seats"
    //   }
    // ],
    // research: [
    //   {
    //     name: "Ph.D. in Humanities & Social Sciences",
    //     duration: "Minimum 3 Years",
    //     eligibility: "M.A. with qualifying exam",
    //     areas: "Sociology, Psychology, Philosophy, Development Studies, Communication Studies"
    //   }
    // ]
  },

Infrastructure: [
  "/infrastructure/hs/class-1.JPG",
  "/infrastructure/hs/lab-1.JPG",
  
]
};
